import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthService } from "@core/services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (this.authService.isAuthenticated) {
      return true;
    }

    const returnUrl = AuthGuard.safeReturnUrl(state.url);

    return this.router.createUrlTree(
      [`/${RoutingPath.Login}`],
      returnUrl ? { queryParams: { returnUrl } } : {}
    );
  }

  static safeReturnUrl(url: string | null | undefined): string | null {
    if (!url || !url.startsWith("/") || url.startsWith("//")) {
      return null;
    }

    const path = url.split("?")[0];

    return path === "/" || path === `/${RoutingPath.Dashboard}` ? null : url;
  }
}
